import { Suspense, useMemo } from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import "./_fonts.scss";
import "./_global.scss";
import ProtectedPageLayout from "./Components/Layouts/ProtectedPageLayout.js";
import PublicRoute from "./Components/Routes/PublicRoute.js";
import TopProgressBar from "./Components/TopProgressBar/TopProgressBar.js";
import { WEB_ROUTES } from "./constants.js";
import { routeConfig } from "./routes.js";
function App() {


  const appRoutes = useMemo(() => {
    return routeConfig.map((route, index) => {
      const {
        component: Component,
        isPublic,
        isProtected,
        layoutProps,
        ...rest
      } = route;
      let pageElement = <Component />;

      if (isProtected) {
        pageElement = (
          <ProtectedPageLayout {...layoutProps}>
            {pageElement}
          </ProtectedPageLayout>
        );
      } else if (isPublic) {
        pageElement = <PublicRoute>{pageElement}</PublicRoute>;
      }

      return (
        <Route key={route.path || index} {...rest} element={pageElement} />
      );
    });
  }, []);



  return (
    <>
      <Router>
        <Suspense fallback={<TopProgressBar />}>
          <Routes>
            {appRoutes}
            <Route path="*" element={<Navigate to={WEB_ROUTES.ACCOUNT} />} />
          </Routes>
        </Suspense>
      </Router>
    </>
  );
}

export default App;
